import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        var splideElements = document.querySelectorAll('.photo-gallery-section__bna__slider');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                // Destroy existing instance if already initialized
                if (splideElement.splide) {
                    splideElement.splide.destroy();
                }

                const counter = splideElement.querySelector('.slider-info .slider-numbers');
                const perPage = parseInt(splideElement.getAttribute('data-per-page')) || 1;

                var splide = new Splide(splideElement, {
                    type: 'slider',
                    speed: 1000,
                    arrows: false,
                    pagination: false,
                    rewind: false,
                    perPage: perPage,
                    perMove: 1,
                    gap: "6%",
                    waitForTransition: false,
                    arrowPath: 'M8.354,0,0,8.353l8.354,8.354L9.06,16,1.915,8.853H16.707v-1H1.915L9.06.706Z',
                    breakpoints: {
                        768: {
                            perPage: 1,
                        }
                    }
                });

                splide.mount();

                // Keep a reference for cleanup
                splideElement.splide = splide;

                // Counter function
                function updateCounter(splide) {
                    if (counter) {
                        var currentSlide = splide.index + 1;
                        var totalSlides = splide.length;
                        counter.textContent = `${currentSlide}/${totalSlides}`;
                    }
                }

                updateCounter(splide);
                splide.on('move', function () {
                    updateCounter(splide);
                });
            });
        }
    }
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=photo-gallery-section', initializeBlock);
    } else {
        initializeBlock();
    }
});
